<template>
  <div>
    <div class="page-header">
      <h3 class="capitalize">Add A Todo</h3>
    </div>
    <div class="alert alert-success" v-if="showAlert()">{{this.alertTitle}} has been added to the <router-link :to="{ name: 'inbox' }">Inbox</router-link></div>
    <span id='js-todo-form' class='js-new-item'>
      <div class="mt-2 js-task-details-collapse-container">
        <div class="input-group mb-3">
          <input type="text" ref="new_todo" class="form-control" v-model="title" @blur="saveTitle" v-on:keyup.enter="saveTitle" placeholder='New Todo Title'>
          <div class="input-group-append">
            <button class="btn btn-primary" type="button">Save</button>
          </div>
        </div>
      </div>
    </span>
  </div>
</template>

<script>
import api from "api";

export default {
  data() {
    return {
      title: '',
      alertTitle: ''
    };
  }, 
  methods: {
    saveTitle: function(event){
      var newTitle = this.title;
      var project_id = null;

      if(newTitle != ''){
        api.createTask({ project_id: project_id, title: newTitle }).then(response => {
          this.alertTitle = this.title;
          this.title = '';
        });
      }
    },
    showAlert(){
      return this.alertTitle !== '' && this.title === ''
    }
  }  
}
</script>
